"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1580],{

/***/ 57495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ Decode; }
/* harmony export */ });
/* harmony import */ var _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91574);
/* harmony import */ var _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77058);
/* harmony import */ var _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35847);
/* harmony import */ var _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37082);
// Generated by ReScript, PLEASE EDIT WITH CARE




function myDetailsData(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        firstName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("first_name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        lastName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("last_name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        email: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("email", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        phone: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("phone", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, json),
        birthdate: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("birthdate", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json),
        profilePictureUrl: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .field */ .EP("profile_picture", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_, param);
        }, json)
    };
}
function safeDecodeMyDetailsData(json) {
    var result;
    try {
        result = myDetailsData(json);
    } catch (raw_e) {
        var e = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_3__/* .internalToOCamlException */ .UW(raw_e);
        if (e.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_2__/* .DecodeError */ ._9) {
            _bindings_Pino_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error({
                err: e._1,
                type: "Safe Decode My Details Data"
            }, "error: Could not decode response from the server");
            return _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .Decode.safeDecodeError */ .f.safeDecodeError(json);
        }
        throw e;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var Decode = {
    myDetailsData: myDetailsData,
    safeDecodeMyDetailsData: safeDecodeMyDetailsData
};
 /* Pino Not a pure module */ 


/***/ }),

/***/ 8092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vw": function() { return /* binding */ Data; },
/* harmony export */   "fJ": function() { return /* binding */ Decode; },
/* harmony export */   "ss": function() { return /* binding */ giftStatusLabelFun; },
/* harmony export */   "uC": function() { return /* binding */ giftFailedDeliveryFun; }
/* harmony export */ });
/* harmony import */ var _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77058);
/* harmony import */ var _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96533);
/* harmony import */ var _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72491);
/* harmony import */ var _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35847);
/* harmony import */ var _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37082);
// Generated by ReScript, PLEASE EDIT WITH CARE





function giftStatusLabelFun(giftStatusLabel) {
    switch(giftStatusLabel){
        case "Cancelled":
            return /* Cancelled */ 5;
        case "Delivered":
            return /* Delivered */ 0;
        case "Delivering":
            return /* Sending */ 8;
        case "Failed":
            return /* Failed */ 2;
        case "Opened":
            return /* Opened */ 1;
        case "Pending":
            return /* Pending */ 4;
        case "Resending":
            return /* Resending */ 3;
        case "Scheduled":
            return /* Scheduled */ 6;
        default:
            return /* Completed */ 7;
    }
}
function giftFailedDeliveryFun(strs) {
    return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(strs, function(str) {
        var match = str.toLowerCase();
        switch(match){
            case "email":
                return /* Email */ 0;
            case "phone":
                return /* Phone */ 1;
            default:
                return;
        }
    });
}
function theme(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        thumbImage: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("thumb_image", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        squareIcon: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("square_icon", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        textureImage: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("texture_image", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        title: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("title", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json)
    };
}
function providerDetails(json) {
    return {
        videoId: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("video_id", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        accountId: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("account_id", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        playerId: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("player_id", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json)
    };
}
function media(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        mediaType: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("media_type", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        provider: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("provider", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        providerDetails: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("provider_details", providerDetails, json)
    };
}
function gift(json) {
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        recipientName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("recipient_name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        recipientEmail: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("recipient_email", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        recipientPhone: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("recipient_phone", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        scheduledDeliveryAt: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("scheduled_delivery_at", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        recipientTimezone: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("recipient_timezone", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        giftStatusLabel: giftStatusLabelFun(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("gift_status_label", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json)),
        giftFailedDelivery: giftFailedDeliveryFun(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("gift_failed_delivery", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json)),
        resendGiftNotificationUrl: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("resend_gift_notification_url", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        updateGiftScheduledDeliveryUrl: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("update_gift_scheduled_delivery_url", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        message: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("message", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        theme: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("theme", theme, json),
        media: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("media", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(media, param);
        }, json)
    };
}
function card(json) {
    return {
        themeImage: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("theme_image", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        expiry: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("expiry", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        value: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("value", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        valueCurrency: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("value_currency", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("sku_uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        skuDisplayName: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("sku_display_name", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        categories: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("categories", function(param) {
                return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
            }, param);
        }, json),
        category: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("category", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        skuSlug: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("sku_slug", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        skuUid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("sku_uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        gift: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("gift", gift, param);
        }, json),
        skuDefaultSwap: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("sku_default_swap", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json)
    };
}
function order(json) {
    var orderStatus = _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("status", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json);
    var tmp = orderStatus === "completed" ? /* Completed */ 0 : /* Cancelled */ 1;
    return {
        uid: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("uid", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        number: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("number", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        createdAt: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("created_at", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        scheduledDeliveryAt: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("scheduled_delivery_at", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        amount: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("amount", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        amountCurrency: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("amount_currency", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        status: tmp,
        isBuyForYourself: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("is_buy_for_yourself", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .bool */ .Xg, json),
        invoiceUrl: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("invoice_url", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, json),
        paymentMethod: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .optional */ .jt(function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("payment_method", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        cards: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("cards", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(card, param);
        }, json)
    };
}
function orders(json) {
    return {
        count: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("count", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .$$int */ .G6, json),
        next: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("next", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        previous: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("previous", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .nullable */ .AG(_glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_, param);
        }, json),
        results: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("results", function(param) {
            return _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX(order, param);
        }, json),
        pageNumber: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("page_number", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .$$int */ .G6, json),
        pageSize: _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .field */ .EP("page_size", _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .$$int */ .G6, json)
    };
}
function safeDecodeOrderData(json) {
    var result;
    try {
        result = orders(json);
    } catch (raw_exn) {
        var exn = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_2__/* .internalToOCamlException */ .UW(raw_exn);
        if (exn.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .DecodeError */ ._9) {
            return _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Decode.safeDecodeError */ .f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
function safeDecodeOrderDetailsData(json) {
    var result;
    try {
        result = order(json);
    } catch (raw_exn) {
        var exn = _rescript_std_lib_es6_caml_js_exceptions_js__WEBPACK_IMPORTED_MODULE_2__/* .internalToOCamlException */ .UW(raw_exn);
        if (exn.RE_EXN_ID === _glennsl_bs_json_src_Json_decode_bs_js__WEBPACK_IMPORTED_MODULE_1__/* .DecodeError */ ._9) {
            return _ErrorData_bs_js__WEBPACK_IMPORTED_MODULE_0__/* .Decode.safeDecodeError */ .f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var Decode = {
    theme: theme,
    providerDetails: providerDetails,
    media: media,
    gift: gift,
    card: card,
    order: order,
    orders: orders,
    safeDecodeOrderData: safeDecodeOrderData,
    safeDecodeOrderDetailsData: safeDecodeOrderDetailsData
};
function dtoToDataItem(res) {
    var _$orders = _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .concatMany */ .ID(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(res.results, function(order) {
        return _rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI(_rescript_std_lib_es6_belt_Array_js__WEBPACK_IMPORTED_MODULE_3__/* .keepMap */ .fe(order.cards, function(card) {
            if (!order.isBuyForYourself && _rescript_std_lib_es6_belt_Option_js__WEBPACK_IMPORTED_MODULE_4__/* .isNone */ .Wi(card.gift)) {
                return;
            } else {
                return card;
            }
        }), function(card) {
            return {
                uid: order.uid,
                number: order.number,
                createdAt: order.createdAt,
                scheduledDeliveryAt: order.scheduledDeliveryAt,
                amount: order.amount,
                amountCurrency: order.amountCurrency,
                status: order.status,
                invoiceUrl: order.invoiceUrl,
                paymentMethod: order.paymentMethod,
                defaultCard: card
            };
        });
    }));
    return {
        count: res.count,
        orders: _$orders,
        page: res.pageNumber,
        pageSize: res.pageSize
    };
}
function sortTypesToString(type_) {
    switch(type_){
        case /* DateDesc */ 0:
            return "DateDesc";
        case /* DateAsc */ 1:
            return "DateAsc";
        case /* Az */ 2:
            return "az";
        case /* Za */ 3:
            return "za";
    }
}
var Data = {
    dtoToDataItem: dtoToDataItem,
    sortTypesToString: sortTypesToString
};
 /* No side effect */ 


/***/ }),

/***/ 91580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d1": function() { return /* binding */ changeEmailAddress; },
  "Sl": function() { return /* binding */ changePhoneNumber; },
  "sx": function() { return /* binding */ deleteProfilePicture; },
  "ns": function() { return /* binding */ editScheduleDelivery; },
  "Dd": function() { return /* binding */ PrezzeeSecureClient_bs_exchange; },
  "ge": function() { return /* binding */ forgotEmailAddress; },
  "VI": function() { return /* binding */ getCardData; },
  "ck": function() { return /* binding */ getCustomerData; },
  "ad": function() { return /* binding */ getMyDetails; },
  "s$": function() { return /* binding */ getOrderDetails; },
  "AU": function() { return /* binding */ getOrders; },
  "kS": function() { return /* binding */ logout; },
  "z2": function() { return /* binding */ PrezzeeSecureClient_bs_register; },
  "YM": function() { return /* binding */ resendGiftCard; },
  "c0": function() { return /* binding */ resetPassword; },
  "iD": function() { return /* binding */ updateFailedOrder; },
  "no": function() { return /* binding */ updateMyDetails; }
});

// UNUSED EXPORTS: account, addWalletNotes, archiveGiftCard, confirmSecurityCode, getSwapCardHistory, login, patchAccountDetails, pollOrderWithRetry, savedCards

// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/bs-fetch/src/Fetch.bs.js
var Fetch_bs = __webpack_require__(90917);
// EXTERNAL MODULE: ./src/bindings/Datadog.bs.js
var Datadog_bs = __webpack_require__(7280);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_dict.js
var js_dict = __webpack_require__(43437);
// EXTERNAL MODULE: ./src/common/Request.bs.js
var Request_bs = __webpack_require__(24429);
// EXTERNAL MODULE: ./src/bindings/Segment.bs.js + 1 modules
var Segment_bs = __webpack_require__(73840);
// EXTERNAL MODULE: ./src/api/Data/ErrorData.bs.js
var ErrorData_bs = __webpack_require__(77058);
// EXTERNAL MODULE: ./node_modules/@glennsl/bs-json/src/Json_decode.bs.js
var Json_decode_bs = __webpack_require__(35847);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_js_exceptions.js
var caml_js_exceptions = __webpack_require__(37082);
;// CONCATENATED MODULE: ./src/api/Data/CardData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function item(json) {
    return {
        themeUid: Json_decode_bs/* field */.EP("theme_uid", Json_decode_bs/* string */.Z_, json),
        themeImage: Json_decode_bs/* field */.EP("theme_image", Json_decode_bs/* string */.Z_, json),
        themekeyColour: Json_decode_bs/* field */.EP("theme_key_colour", Json_decode_bs/* string */.Z_, json),
        themeTextColour: Json_decode_bs/* field */.EP("theme_text_colour", Json_decode_bs/* string */.Z_, json),
        value: Json_decode_bs/* field */.EP("value", Json_decode_bs/* string */.Z_, json),
        originalBalance: Json_decode_bs/* field */.EP("original_balance", Json_decode_bs/* string */.Z_, json),
        valueCurrency: Json_decode_bs/* field */.EP("value_currency", Json_decode_bs/* string */.Z_, json),
        originalBalanceCurrency: Json_decode_bs/* field */.EP("original_balance_currency", Json_decode_bs/* string */.Z_, json),
        balance: Json_decode_bs/* field */.EP("balance", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        balanceCurrency: Json_decode_bs/* field */.EP("balance_currency", Json_decode_bs/* string */.Z_, json),
        expiry: Json_decode_bs/* field */.EP("expiry", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        isExpired: Json_decode_bs/* field */.EP("is_expired", Json_decode_bs/* bool */.Xg, json),
        balanceUpdatedAt: Json_decode_bs/* field */.EP("balance_updated_at", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        notes: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        productType: Json_decode_bs/* field */.EP("product_type", Json_decode_bs/* string */.Z_, json),
        cardLabel: Json_decode_bs/* field */.EP("card_label", Json_decode_bs/* string */.Z_, json),
        cardPin: Json_decode_bs/* field */.EP("card_pin", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        cardId: Json_decode_bs/* field */.EP("card_id", Json_decode_bs/* string */.Z_, json),
        number: Json_decode_bs/* field */.EP("number", Json_decode_bs/* string */.Z_, json),
        barcodeNumber: Json_decode_bs/* field */.EP("barcode_number", Json_decode_bs/* string */.Z_, json),
        barcodeLabel: Json_decode_bs/* field */.EP("barcode_label", Json_decode_bs/* string */.Z_, json),
        instoreNumber: Json_decode_bs/* field */.EP("instore_number", Json_decode_bs/* string */.Z_, json),
        onlineNumber: Json_decode_bs/* field */.EP("online_number", Json_decode_bs/* string */.Z_, json),
        pin: Json_decode_bs/* field */.EP("pin", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        pinFieldName: Json_decode_bs/* field */.EP("pin_field_name", Json_decode_bs/* string */.Z_, json),
        cardBarcodeFormat: Json_decode_bs/* field */.EP("card_barcode_format", Json_decode_bs/* string */.Z_, json),
        cardLogo: Json_decode_bs/* field */.EP("card_logo", Json_decode_bs/* string */.Z_, json),
        merchantTerms: Json_decode_bs/* field */.EP("merchant_terms", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        status: Json_decode_bs/* field */.EP("status", Json_decode_bs/* string */.Z_, json),
        subtype: Json_decode_bs/* field */.EP("subtype", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        updatedAt: Json_decode_bs/* field */.EP("updated_at", Json_decode_bs/* string */.Z_, json),
        activatedAt: Json_decode_bs/* field */.EP("activated_at", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        createdAt: Json_decode_bs/* field */.EP("created_at", Json_decode_bs/* string */.Z_, json),
        receivedAt: Json_decode_bs/* field */.EP("received_at", Json_decode_bs/* string */.Z_, json),
        gift: null,
        isSwapCard: Json_decode_bs/* field */.EP("is_swap_card", Json_decode_bs/* bool */.Xg, json),
        isSchemeCard: Json_decode_bs/* field */.EP("is_scheme_card", Json_decode_bs/* bool */.Xg, json),
        swapCard: Json_decode_bs/* field */.EP("swap_card", Json_decode_bs/* bool */.Xg, json),
        donation: Json_decode_bs/* field */.EP("donation", Json_decode_bs/* bool */.Xg, json),
        supportsRegift: Json_decode_bs/* field */.EP("supports_regift", Json_decode_bs/* bool */.Xg, json),
        supportsBalanceCheck: Json_decode_bs/* field */.EP("supports_balance_check", Json_decode_bs/* bool */.Xg, json),
        supportsAppleWalletExport: Json_decode_bs/* field */.EP("supports_apple_wallet_export", Json_decode_bs/* bool */.Xg, json),
        supportsGoogleWalletExport: Json_decode_bs/* field */.EP("supports_google_wallet_export", Json_decode_bs/* bool */.Xg, json),
        receiptText: Json_decode_bs/* field */.EP("receipt_text", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        receiptLogoTop: Json_decode_bs/* field */.EP("receipt_logo_top", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        redemptionUrl: Json_decode_bs/* field */.EP("redemption_url", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        balanceCheckUrl: Json_decode_bs/* field */.EP("balance_check_url", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        howToUse: Json_decode_bs/* field */.EP("how_to_use", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        skuDisplayName: Json_decode_bs/* field */.EP("sku_display_name", Json_decode_bs/* string */.Z_, json),
        skuUid: Json_decode_bs/* field */.EP("sku_uid", Json_decode_bs/* string */.Z_, json),
        pdfUrl: Json_decode_bs/* field */.EP("pdf_url", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        defaultProductCode: Json_decode_bs/* field */.EP("default_product_code", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        defaultProductThemeCode: Json_decode_bs/* field */.EP("default_product_theme_code", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        defaultSkuUid: Json_decode_bs/* field */.EP("default_sku_uid", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json)
    };
}
function safeDecodeCardData(json) {
    var result;
    try {
        result = item(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var Decode = {
    item: item,
    safeDecodeCardData: safeDecodeCardData
};
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_null_undefined.js
var js_null_undefined = __webpack_require__(11236);
;// CONCATENATED MODULE: ./src/api/Data/Customer.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function card(json) {
    return {
        themeUid: Json_decode_bs/* field */.EP("theme_uid", Json_decode_bs/* string */.Z_, json),
        themeImage: Json_decode_bs/* field */.EP("theme_image", Json_decode_bs/* string */.Z_, json)
    };
}
function wallet(json) {
    return {
        cards: Json_decode_bs/* field */.EP("cards", function(param) {
            return Json_decode_bs/* array */.IX(card, param);
        }, json)
    };
}
function customer(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        firstName: Json_decode_bs/* field */.EP("first_name", Json_decode_bs/* string */.Z_, json),
        lastName: Json_decode_bs/* field */.EP("last_name", Json_decode_bs/* string */.Z_, json),
        wallet: Json_decode_bs/* field */.EP("wallet", function(param) {
            return Json_decode_bs/* nullable */.AG(wallet, param);
        }, json)
    };
}
function safeDecodeCustomer(json) {
    var customer$1;
    try {
        customer$1 = customer(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return js_null_undefined/* fromOption */.Yo(undefined);
        }
        throw exn;
    }
    return js_null_undefined/* fromOption */.Yo(customer$1);
}
var Customer_bs_Decode = {
    card: card,
    wallet: wallet,
    customer: customer,
    safeDecodeCustomer: safeDecodeCustomer
};
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/ApiErrors.bs.js
var ApiErrors_bs = __webpack_require__(44054);
// EXTERNAL MODULE: ./src/auth/user/AuthUtils.bs.js + 1 modules
var AuthUtils_bs = __webpack_require__(45603);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_List.js
var belt_List = __webpack_require__(84462);
// EXTERNAL MODULE: ./node_modules/@glennsl/bs-json/src/Json_encode.bs.js
var Json_encode_bs = __webpack_require__(64221);
;// CONCATENATED MODULE: ./src/api/Data/LoginData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function login(l) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "email",
            l.email
        ],
        tl: {
            hd: [
                "password",
                l.password
            ],
            tl: /* [] */ 0
        }
    });
}
var Encode = {
    login: login
};
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/Data/OrderData.bs.js
var OrderData_bs = __webpack_require__(8092);
;// CONCATENATED MODULE: ./src/api/Data/TokenData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function token(json) {
    return {
        walletIsEmpty: Json_decode_bs/* field */.EP("wallet_is_empty", Json_decode_bs/* bool */.Xg, json),
        accessToken: Json_decode_bs/* field */.EP("access_token", Json_decode_bs/* string */.Z_, json)
    };
}
function safeDecodeTokenData(json) {
    var value;
    try {
        value = token(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: value
    };
}
var TokenData_bs_Decode = {
    token: token,
    safeDecodeTokenData: safeDecodeTokenData
};
 /* No side effect */ 

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_promise.js
var js_promise = __webpack_require__(27097);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_format.js
var caml_format = __webpack_require__(11331);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/caml_option.js
var caml_option = __webpack_require__(25400);
;// CONCATENATED MODULE: ./src/api/Data/HistoryData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function HistoryData_bs_item(json) {
    return {
        uid: Json_decode_bs/* field */.EP("uid", Json_decode_bs/* string */.Z_, json),
        cardLabel: Json_decode_bs/* field */.EP("card_label", Json_decode_bs/* string */.Z_, json),
        themeImage: Json_decode_bs/* field */.EP("theme_image", Json_decode_bs/* string */.Z_, json),
        value: Json_decode_bs/* field */.EP("value", Json_decode_bs/* string */.Z_, json),
        valueCurrency: Json_decode_bs/* field */.EP("value_currency", Json_decode_bs/* string */.Z_, json),
        originalBalance: Json_decode_bs/* field */.EP("original_balance", Json_decode_bs/* string */.Z_, json),
        originalBalanceCurrency: Json_decode_bs/* field */.EP("original_balance_currency", Json_decode_bs/* string */.Z_, json),
        activatedAt: Json_decode_bs/* field */.EP("activated_at", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        archivedAt: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("archived_at", Json_decode_bs/* string */.Z_, param);
        }, json)
    };
}
function HistoryData_bs_all(json) {
    return Json_decode_bs/* array */.IX(HistoryData_bs_item, json);
}
function safeDecodeCardHistory(json) {
    var result;
    try {
        result = Json_decode_bs/* array */.IX(HistoryData_bs_item, json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var HistoryData_bs_Decode = {
    item: HistoryData_bs_item,
    all: HistoryData_bs_all,
    safeDecodeCardHistory: safeDecodeCardHistory
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/Data/OrderStatus.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function errorDecoder(json) {
    return {
        code: Json_decode_bs/* field */.EP("code", Json_decode_bs/* $$int */.G6, json),
        detail: Json_decode_bs/* field */.EP("detail", Json_decode_bs/* string */.Z_, json)
    };
}
function orderStatus(json) {
    return {
        status: Json_decode_bs/* field */.EP("status", Json_decode_bs/* string */.Z_, json),
        error: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("error", errorDecoder, param);
        }, json)
    };
}
function safeDecodeOrderStatus(json) {
    var result;
    try {
        result = orderStatus(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: result
    };
}
var OrderStatus_bs_Decode = {
    errorDecoder: errorDecoder,
    orderStatus: orderStatus,
    safeDecodeOrderStatus: safeDecodeOrderStatus
};
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/Data/CustomerData.bs.js
var CustomerData_bs = __webpack_require__(65496);
;// CONCATENATED MODULE: ./src/api/Data/ExchangeData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE

function ExchangeData_bs_item(l) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "product_code",
            l.productCode
        ],
        tl: {
            hd: [
                "product_theme_code",
                l.productThemeCode
            ],
            tl: /* [] */ 0
        }
    });
}
function exchange(l) {
    return Json_encode_bs/* object_ */.GN({
        hd: [
            "items",
            Json_encode_bs/* list */.pb(ExchangeData_bs_item, l.items)
        ],
        tl: /* [] */ 0
    });
}
var ExchangeData_bs_Encode = {
    item: ExchangeData_bs_item,
    exchange: exchange
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/Data/RegisterData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function register(l) {
    var orderNumber = belt_Option/* mapWithDefault */.k7(l.orderNumber, /* [] */ 0, function(number) {
        return {
            hd: [
                "claim_order_number",
                number
            ],
            tl: /* [] */ 0
        };
    });
    return Json_encode_bs/* object_ */.GN(belt_List/* concat */.zo({
        hd: [
            "first_name",
            l.firstName
        ],
        tl: {
            hd: [
                "last_name",
                l.lastName
            ],
            tl: {
                hd: [
                    "email",
                    l.email
                ],
                tl: {
                    hd: [
                        "phone",
                        l.phoneNumber
                    ],
                    tl: {
                        hd: [
                            "password",
                            l.password
                        ],
                        tl: {
                            hd: [
                                "security_code",
                                l.securityCode
                            ],
                            tl: {
                                hd: [
                                    "marketing_optin",
                                    l.marketingOptIn
                                ],
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }, orderNumber));
}
var RegisterData_bs_Encode = {
    register: register
};
 /* No side effect */ 

// EXTERNAL MODULE: ./src/api/Data/MyDetailsData.bs.js
var MyDetailsData_bs = __webpack_require__(57495);
;// CONCATENATED MODULE: ./src/api/Data/CreditCardData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function address(json) {
    return {
        city: Json_decode_bs/* field */.EP("city", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        country: Json_decode_bs/* field */.EP("country", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        line1: Json_decode_bs/* field */.EP("line1", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        postCode: Json_decode_bs/* field */.EP("postal_code", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json),
        state: Json_decode_bs/* field */.EP("state", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json)
    };
}
function cardDetails(json) {
    var cardBrand = Json_decode_bs/* field */.EP("brand", Json_decode_bs/* string */.Z_, json);
    return {
        brand: cardBrand === "visa" ? /* Visa */ 0 : cardBrand === "amex" ? /* Amex */ 2 : cardBrand === "jcb" ? /* JCB */ 3 : cardBrand === "mastercard" ? /* Mastercard */ 1 : /* Others */ 4,
        country: Json_decode_bs/* field */.EP("country", Json_decode_bs/* string */.Z_, json),
        expiryMonth: Json_decode_bs/* field */.EP("exp_month", Json_decode_bs/* $$int */.G6, json),
        expiryYear: Json_decode_bs/* field */.EP("exp_year", Json_decode_bs/* $$int */.G6, json),
        fingerPrint: Json_decode_bs/* field */.EP("fingerprint", Json_decode_bs/* string */.Z_, json),
        funding: Json_decode_bs/* field */.EP("funding", Json_decode_bs/* string */.Z_, json),
        last4Digits: Json_decode_bs/* field */.EP("last4", Json_decode_bs/* string */.Z_, json)
    };
}
function billingDetails(json) {
    return {
        address: Json_decode_bs/* field */.EP("address", address, json),
        name: Json_decode_bs/* field */.EP("name", function(param) {
            return Json_decode_bs/* nullable */.AG(Json_decode_bs/* string */.Z_, param);
        }, json)
    };
}
function savedCard(json) {
    return {
        paymentMethodId: Json_decode_bs/* field */.EP("payment_method_id", Json_decode_bs/* string */.Z_, json),
        cardDetails: Json_decode_bs/* field */.EP("card_details", cardDetails, json),
        billingDetails: Json_decode_bs/* field */.EP("billing_details", billingDetails, json)
    };
}
function savedCards(json) {
    return Json_decode_bs/* array */.IX(savedCard, json);
}
function safeDecode(json) {
    var value;
    try {
        value = Json_decode_bs/* array */.IX(savedCard, json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: value
    };
}
var CreditCardData_bs_Decode = {
    address: address,
    cardDetails: cardDetails,
    billingDetails: billingDetails,
    savedCard: savedCard,
    savedCards: savedCards,
    safeDecode: safeDecode
};
var SavedCard = {
    Decode: CreditCardData_bs_Decode
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/Data/ResendGiftData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function resendGiftResponse(json) {
    return {
        giftStatusLabel: OrderData_bs/* giftStatusLabelFun */.ss(Json_decode_bs/* field */.EP("gift_status_label", Json_decode_bs/* string */.Z_, json)),
        giftFailedDelivery: OrderData_bs/* giftFailedDeliveryFun */.uC(Json_decode_bs/* field */.EP("gift_failed_delivery", function(param) {
            return Json_decode_bs/* array */.IX(Json_decode_bs/* string */.Z_, param);
        }, json))
    };
}
function safeDecodeResendResponse(json) {
    var value;
    try {
        value = resendGiftResponse(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: value
    };
}
var ResendGiftData_bs_Decode = {
    resendGiftResponse: resendGiftResponse,
    safeDecodeResendResponse: safeDecodeResendResponse
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/Data/RegisterResponseData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE



function registerResponse(json) {
    return {
        walletIsEmpty: Json_decode_bs/* field */.EP("wallet_is_empty", Json_decode_bs/* bool */.Xg, json),
        accessToken: Json_decode_bs/* field */.EP("access_token", Json_decode_bs/* string */.Z_, json)
    };
}
function safeDecodeRegisterResponse(json) {
    var value;
    try {
        value = registerResponse(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: value
    };
}
var RegisterResponseData_bs_Decode = {
    registerResponse: registerResponse,
    safeDecodeRegisterResponse: safeDecodeRegisterResponse
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/Data/EditScheduleDeliveryData.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE




function editScheduleDeliveryResponse(json) {
    return {
        giftStatusLabel: OrderData_bs/* giftStatusLabelFun */.ss(Json_decode_bs/* field */.EP("gift_status_label", Json_decode_bs/* string */.Z_, json)),
        giftFailedDelivery: OrderData_bs/* giftFailedDeliveryFun */.uC(Json_decode_bs/* field */.EP("gift_failed_delivery", function(param) {
            return Json_decode_bs/* array */.IX(Json_decode_bs/* string */.Z_, param);
        }, json)),
        scheduledDeliveryAt: Json_decode_bs/* optional */.jt(function(param) {
            return Json_decode_bs/* field */.EP("scheduled_delivery_at", Json_decode_bs/* string */.Z_, param);
        }, json)
    };
}
function EditScheduleDeliveryData_bs_safeDecodeResendResponse(json) {
    var value;
    try {
        value = editScheduleDeliveryResponse(json);
    } catch (raw_exn) {
        var exn = caml_js_exceptions/* internalToOCamlException */.UW(raw_exn);
        if (exn.RE_EXN_ID === Json_decode_bs/* DecodeError */._9) {
            return ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json);
        }
        throw exn;
    }
    return {
        TAG: /* Ok */ 0,
        _0: value
    };
}
var EditScheduleDeliveryData_bs_Decode = {
    editScheduleDeliveryResponse: editScheduleDeliveryResponse,
    safeDecodeResendResponse: EditScheduleDeliveryData_bs_safeDecodeResendResponse
};
 /* No side effect */ 

;// CONCATENATED MODULE: ./src/api/PrezzeeSecureClient.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE
































function PrezzeeSecureClient_bs_login(login$1) {
    var payload = LoginData.Encode.login(login$1);
    var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined)));
    var callback = function callback(response) {
        return $$Request.checkResponse(response, TokenData.Decode.safeDecodeTokenData);
    };
    var request = Fetch.RequestInit.make(/* Post */ 2, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* Include */ 2, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch.RequestInit.make(/* Post */ 2, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* Include */ 2, undefined, undefined, undefined, undefined, undefined)(undefined);
    return $$Request.makeRequest($$Request.makeUrl("api/v3/signin-by-email-password/email/"), request, headerlessRequest, callback, true);
}
function PrezzeeSecureClient_bs_register(registerData) {
    var payload = RegisterData_bs_Encode.register(registerData);
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withSecurityToken */.oK.withSecurityToken(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, RegisterResponseData_bs_Decode.safeDecodeRegisterResponse);
    };
    return Request_bs/* makeRequest */.$f(Request_bs/* makeUrl */.bf("api/v3/register-by-email-password/email/"), request, headerlessRequest, callback, true);
}
function account(firstName, lastName) {
    var payload = Js_dict.fromList({
        hd: [
            "first_name",
            firstName
        ],
        tl: {
            hd: [
                "last_name",
                lastName
            ],
            tl: /* [] */ 0
        }
    });
    var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
    var url = $$Request.makeUrl("api/v3/customer/");
    var request = Fetch.RequestInit.make(/* Put */ 3, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch.RequestInit.make(/* Put */ 3, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog.Logger.requestInfo("Request " + url, headerlessRequest, $$Request.logger);
    return Js_promise.then_(function(response) {
        Datadog.Logger.responseInfo("Response " + url, response, $$Request.logger);
        var n = response.status;
        if (n !== 200) {
            if (n >= 400 && n < 500) {
                return Js_promise.then_(function(json) {
                    return Promise.resolve(ErrorData.Decode.safeDecodeError(json));
                }, Fetch.$$Response.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors.networkError(undefined, n)
                });
            }
        } else {
            return Js_promise.then_(function(json) {
                return Promise.resolve({
                    TAG: /* Ok */ 0,
                    _0: Customer.Decode.safeDecodeCustomer(json)
                });
            }, Fetch.$$Response.json(response));
        }
    }, fetch(url, request));
}
function forgotEmailAddress(phone) {
    var payload = js_dict/* fromList */.hy({
        hd: [
            "phone",
            phone
        ],
        tl: /* [] */ 0
    });
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var url = Request_bs/* makeUrl */.bf("api/v3/forgot-email-address/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog_bs/* Logger.requestInfo */.Y.requestInfo("Request " + url, headerlessRequest, Request_bs/* logger */.kg);
    return js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, response, Request_bs/* logger */.kg);
        var n = response.status;
        if (n !== 204) {
            if (n >= 400 && n < 500) {
                return js_promise/* then_ */.k(function(json) {
                    return Promise.resolve(ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json));
                }, Fetch_bs/* $$Response.json */.PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: response
            });
        }
    }, fetch(url, request));
}
function resetPassword(email) {
    var payload = js_dict/* fromList */.hy({
        hd: [
            "email_address",
            email
        ],
        tl: /* [] */ 0
    });
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var url = Request_bs/* makeUrl */.bf("api/v3/reset-password/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog_bs/* Logger.requestInfo */.Y.requestInfo("Request " + url, headerlessRequest, Request_bs/* logger */.kg);
    return js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, response, Request_bs/* logger */.kg);
        var n = response.status;
        if (n !== 204) {
            if (n >= 400 && n < 500) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* ServerError */ 2,
                        _0: {
                            TAG: /* ServerValidationError */ 0,
                            _0: "Invalid Email Address"
                        }
                    }
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: response
            });
        }
    }, fetch(url, request));
}
function changeEmailAddress(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.build */.oK.build(undefined)));
    var url = Request_bs/* makeUrl */.bf("api/v3/change-email-address/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), undefined, undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, undefined, undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog_bs/* Logger.requestInfo */.Y.requestInfo("Request " + url, headerlessRequest, Request_bs/* logger */.kg);
    return js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, response, Request_bs/* logger */.kg);
        var n = response.status;
        if (n !== 204) {
            if (n >= 400 && n < 500) {
                return js_promise/* then_ */.k(function(json) {
                    return Promise.resolve(ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json));
                }, Fetch_bs/* $$Response.json */.PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: response
            });
        }
    }, fetch(url, request));
}
function changePhoneNumber(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.build */.oK.build(undefined)));
    var url = Request_bs/* makeUrl */.bf("api/v3/change-phone-number/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), undefined, undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, undefined, undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog_bs/* Logger.requestInfo */.Y.requestInfo("Request " + url, headerlessRequest, Request_bs/* logger */.kg);
    return js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, response, Request_bs/* logger */.kg);
        var n = response.status;
        if (n !== 204) {
            if (n >= 400 && n < 500) {
                return js_promise/* then_ */.k(function(json) {
                    return Promise.resolve(ErrorData_bs/* Decode.safeDecodeError */.f.safeDecodeError(json));
                }, Fetch_bs/* $$Response.json */.PX.json(response));
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: response
            });
        }
    }, fetch(url, request));
}
function getCardData(cardUid) {
    var route = "api/v3/card/" + (cardUid + "/");
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, Decode.safeDecodeCardData);
    };
    return Request_bs/* makeRequest */.$f(Request_bs/* makeUrl */.bf(route), request, headerlessRequest, callback, true);
}
function getCustomerData(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, CustomerData_bs/* Decode.safeDecodeCustomerData */.f.safeDecodeCustomerData);
    };
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    return Request_bs/* makeRequest */.$f(Request_bs/* makeUrl */.bf("api/v3/customer/"), request, headerlessRequest, callback, true);
}
function getSwapCardHistory(cardUid) {
    var route = "api/v3/card/" + (cardUid + "/exchange-history");
    var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
    var request = Fetch.RequestInit.make(/* Get */ 0, Caml_option.some(headers), undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch.RequestInit.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return $$Request.checkResponse(response, HistoryData.Decode.safeDecodeCardHistory);
    };
    return $$Request.makeRequest($$Request.makeUrl(route), request, headerlessRequest, callback, true);
}
function archiveGiftCard(cardUid) {
    var route = "api/v3/card/" + (cardUid + "/archive");
    var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.build(undefined)));
    var request = Fetch.RequestInit.make(/* Put */ 3, Caml_option.some(headers), undefined, undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch.RequestInit.make(/* Put */ 3, undefined, undefined, undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return $$Request.checkResponse(response, function(x) {
            return {
                TAG: /* Ok */ 0,
                _0: x
            };
        });
    };
    return $$Request.makeRequest($$Request.makeUrl(route), request, headerlessRequest, callback, true);
}
function confirmSecurityCode(securityCode) {
    var payload = Js_dict.fromList({
        hd: [
            "code",
            securityCode
        ],
        tl: /* [] */ 0
    });
    var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
    var url = $$Request.makeUrl("api/v3/customer/securitycode/validate/");
    var request = Fetch.RequestInit.make(/* Post */ 2, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch.RequestInit.make(/* Post */ 2, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog.Logger.requestInfo("Request " + url, headerlessRequest, $$Request.logger);
    return Js_promise.then_(function(response) {
        Datadog.Logger.responseInfo("Response " + url, response, $$Request.logger);
        var n = response.status;
        if (n !== 200 && n !== 204) {
            if (n >= 400 && n < 500) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* ServerError */ 2,
                        _0: {
                            TAG: /* ServerValidationError */ 0,
                            _0: "Invalid security"
                        }
                    }
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors.networkError(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: response
            });
        }
    }, fetch(url, request));
}
function pollOrderWithRetry(orderUrl, dispatchExchangeAction, retryCount) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    js_promise/* $$catch */.y(function(param) {
        return Promise.resolve(curry._1(dispatchExchangeAction, {
            TAG: /* NotifySwapFailure */ 5,
            _0: "000"
        }));
    }, js_promise/* then_ */.k(function(resp) {
        var hs = resp.headers;
        var retryAfterOpt = belt_Option/* flatMap */.VS(Fetch_bs/* $$Headers.get */.ye.get("retry-after", hs), function(x) {
            return Math.imul(caml_format/* int_of_string */.di(x), 1000);
        });
        var retry = function retry(param) {
            belt_Option/* mapWithDefault */.k7(retryAfterOpt, undefined, function(retryAfter) {
                if (retryCount > 0) {
                    setTimeout(function(param) {
                        pollOrderWithRetry(orderUrl, dispatchExchangeAction, retryCount - 1 | 0);
                    }, retryAfter);
                } else {
                    curry._1(dispatchExchangeAction, {
                        TAG: /* NotifySwapFailure */ 5,
                        _0: "000"
                    });
                }
            });
        };
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response (polling)", resp, Request_bs/* logger */.kg);
        return js_promise/* then_ */.k(function(result) {
            if (result.TAG !== /* Ok */ 0) {
                return Promise.resolve(belt_Option/* isSome */.pC(retryAfterOpt) ? retry(undefined) : curry._1(dispatchExchangeAction, {
                    TAG: /* NotifySwapFailure */ 5,
                    _0: "000"
                }));
            }
            var os = result._0;
            if (os.status === "DRAFT" && belt_Option/* isSome */.pC(retryAfterOpt)) {
                return Promise.resolve(retry(undefined));
            }
            if (os.status === "COMPLETED") {
                return Promise.resolve(curry._1(dispatchExchangeAction, /* NotifySwapSuccess */ 12));
            }
            if (os.status === "PROCESSING" && belt_Option/* isSome */.pC(retryAfterOpt)) {
                return Promise.resolve(retry(undefined));
            }
            if (os.status === "FAILED") {
                return Promise.resolve(curry._1(dispatchExchangeAction, {
                    TAG: /* NotifySwapFailure */ 5,
                    _0: "000"
                }));
            }
            if (os.status === "CANCELLED") {
                return Promise.resolve(curry._1(dispatchExchangeAction, {
                    TAG: /* NotifySwapFailure */ 5,
                    _0: "000"
                }));
            }
            var errorData = os.error;
            return Promise.resolve(errorData !== undefined ? curry._1(dispatchExchangeAction, {
                TAG: /* NotifySwapFailure */ 5,
                _0: String(errorData.code)
            }) : belt_Option/* isSome */.pC(retryAfterOpt) ? retry(undefined) : curry._1(dispatchExchangeAction, {
                TAG: /* NotifySwapFailure */ 5,
                _0: "000"
            }));
        }, Request_bs/* checkResponse */.mm(resp, OrderStatus_bs_Decode.safeDecodeOrderStatus));
    }, fetch(orderUrl, request)));
}
function PrezzeeSecureClient_bs_exchange(swapCard, cart, dispatchExchangeAction) {
    var uid = swapCard !== undefined ? swapCard.TAG === /* WalletCard */ 0 ? swapCard._0.uid : swapCard._0.uid : "";
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withPreferRespondAsync */.oK.withPreferRespondAsync(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined)))));
    var route = "api/v3/exchange/" + (uid + "/");
    var payload = ExchangeData_bs_Encode.exchange({
        items: belt_List/* map */.UI(cart, function(swapItem) {
            return {
                productCode: belt_Option/* getWithDefault */.tj(swapItem.productCode, ""),
                productThemeCode: belt_Option/* mapWithDefault */.k7(belt_Array/* get */.U2(swapItem.card.themes, 0), "", function(theme) {
                    return theme.code;
                })
            };
        })
    });
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var url = Request_bs/* makeUrl */.bf(route);
    Datadog_bs/* Logger.requestInfo */.Y.requestInfo("Request " + url, headerlessRequest, Request_bs/* logger */.kg);
    return js_promise/* then_ */.k(function(resp) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, resp, Request_bs/* logger */.kg);
        var hs = resp.headers;
        var orderUrlOpt = Fetch_bs/* $$Headers.get */.ye.get("content-location", hs);
        if (orderUrlOpt !== undefined) {
            return Promise.resolve(pollOrderWithRetry(orderUrlOpt, dispatchExchangeAction, 5));
        } else {
            return Promise.resolve(curry._1(dispatchExchangeAction, {
                TAG: /* NotifySwapFailure */ 5,
                _0: "000"
            }));
        }
    }, fetch(url, request));
}
function addWalletNotes(cardUid, notes) {
    var payload = Js_dict.fromList({
        hd: [
            "message",
            notes
        ],
        tl: /* [] */ 0
    });
    var route = "api/v3/card/" + (cardUid + "/note/");
    var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
    var request = Fetch.RequestInit.make(/* Post */ 2, Caml_option.some(headers), Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch.RequestInit.make(/* Post */ 2, undefined, Caml_option.some(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return $$Request.checkResponse(response, function(x) {
            return {
                TAG: /* Ok */ 0,
                _0: x
            };
        });
    };
    return $$Request.makeRequest($$Request.makeUrl(route), request, headerlessRequest, callback, true);
}
function logout(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var url = Request_bs/* makeUrl */.bf("api/v3/signout/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), undefined, undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, undefined, undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    Datadog_bs/* Logger.requestInfo */.Y.requestInfo("Request " + url, headerlessRequest, Request_bs/* logger */.kg);
    return js_promise/* then_ */.k(function(response) {
        Datadog_bs/* Logger.responseInfo */.Y.responseInfo("Response " + url, response, Request_bs/* logger */.kg);
        js_cookie.remove(AuthUtils_bs/* cookieName */.YN);
        js_cookie.remove("sessionid");
        Segment_bs/* signedOut */.Cz({});
        Segment_bs/* reset */.mc(undefined);
        var n = response.status;
        if (n !== 200 && n !== 204) {
            if (n >= 400 && n < 500) {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: {
                        TAG: /* ServerError */ 2,
                        _0: {
                            TAG: /* ServerValidationError */ 0,
                            _0: "Logout Failed"
                        }
                    }
                });
            } else {
                return Promise.resolve({
                    TAG: /* Error */ 1,
                    _0: ApiErrors_bs/* networkError */.E(undefined, n)
                });
            }
        } else {
            return Promise.resolve({
                TAG: /* Ok */ 0,
                _0: ""
            });
        }
    }, fetch(url, request));
}
function PrezzeeSecureClient_bs_savedCards(param) {
    var headers = Util.HeadersUtil.makeWithArray(Util.HeadersUtil.withAuthHeaderIfAvailable(Util.HeadersUtil.withContentTypeJson(Util.HeadersUtil.build(undefined))));
    var request = Fetch.RequestInit.make(/* Get */ 0, Caml_option.some(headers), undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch.RequestInit.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return $$Request.checkResponse(response, CreditCardData.SavedCard.Decode.safeDecode);
    };
    return $$Request.makeRequest($$Request.makeUrl("api/v3/stripe/cards/"), request, headerlessRequest, callback, true);
}
function getOrders(sort, pageNumber) {
    var route = "api/v3/account/orders/?sort=" + (OrderData_bs/* Data.sortTypesToString */.Vw.sortTypesToString(sort) + ("&page_size=6&page=" + String(pageNumber)));
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, OrderData_bs/* Decode.safeDecodeOrderData */.fJ.safeDecodeOrderData);
    };
    return Request_bs/* makeRequest */.$f(Request_bs/* makeUrl */.bf(route), request, headerlessRequest, callback, true);
}
function getOrderDetails(orderUid, giftUid) {
    var route = giftUid !== undefined ? "api/v3/account/orders/" + (orderUid + ("/gift/" + giftUid)) : "api/v3/account/orders/" + orderUid;
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, OrderData_bs/* Decode.safeDecodeOrderDetailsData */.fJ.safeDecodeOrderDetailsData);
    };
    return Request_bs/* makeRequest */.$f(Request_bs/* makeUrl */.bf(route), request, headerlessRequest, callback, true);
}
function getMyDetails(param) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, caml_option/* some */.G(headers), undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Get */ 0, undefined, undefined, undefined, undefined, undefined, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, MyDetailsData_bs/* Decode.safeDecodeMyDetailsData */.f.safeDecodeMyDetailsData);
    };
    return Request_bs/* makeRequest */.$f(Request_bs/* makeUrl */.bf("api/v3/account/details/"), request, headerlessRequest, callback, true);
}
function patchAccountDetails(payload) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var url = Request_bs/* makeUrl */.bf("api/v3/account/details/");
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Patch */ 8, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Patch */ 8, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, MyDetailsData_bs/* Decode.safeDecodeMyDetailsData */.f.safeDecodeMyDetailsData);
    };
    return Request_bs/* makeRequest */.$f(url, request, headerlessRequest, callback, true);
}
function deleteProfilePicture(param) {
    return patchAccountDetails(js_dict/* fromList */.hy({
        hd: [
            "profile_picture",
            null
        ],
        tl: /* [] */ 0
    }));
}
function updateMyDetails(firstName, lastName, birthdate) {
    return patchAccountDetails(js_dict/* fromList */.hy({
        hd: [
            "first_name",
            firstName
        ],
        tl: {
            hd: [
                "last_name",
                lastName
            ],
            tl: {
                hd: [
                    "birthdate",
                    birthdate !== "" ? birthdate : null
                ],
                tl: /* [] */ 0
            }
        }
    }));
}
function resendGiftCard(resendGiftNotificationUrl) {
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.build */.oK.build(undefined)));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), undefined, undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, undefined, undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, ResendGiftData_bs_Decode.safeDecodeResendResponse);
    };
    return Request_bs/* makeRequest */.$f(resendGiftNotificationUrl, request, headerlessRequest, callback, true);
}
function updateFailedOrder(payload) {
    var body = js_dict/* fromList */.hy({
        hd: [
            "new_email",
            belt_Option/* mapWithDefault */.k7(payload.newEmail, null, function(newEmail) {
                return newEmail;
            })
        ],
        tl: {
            hd: [
                "new_phone",
                belt_Option/* mapWithDefault */.k7(payload.newPhone, null, function(newPhone) {
                    return newPhone;
                })
            ],
            tl: /* [] */ 0
        }
    });
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(body)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Post */ 2, undefined, caml_option/* some */.G(JSON.stringify(body)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, ResendGiftData_bs_Decode.safeDecodeResendResponse);
    };
    return Request_bs/* makeRequest */.$f(payload.url, request, headerlessRequest, callback, true);
}
function editScheduleDelivery(scheduledDeliveryAt, updateGiftScheduledDeliveryUrl, recipientTimezone) {
    var payload = js_dict/* fromList */.hy({
        hd: [
            "scheduled_delivery_at",
            scheduledDeliveryAt === "" ? null : scheduledDeliveryAt
        ],
        tl: {
            hd: [
                "recipient_timezone",
                recipientTimezone === "" ? null : recipientTimezone
            ],
            tl: /* [] */ 0
        }
    });
    var headers = util_bs/* HeadersUtil.makeWithArray */.oK.makeWithArray(util_bs/* HeadersUtil.withAuthHeaderIfAvailable */.oK.withAuthHeaderIfAvailable(util_bs/* HeadersUtil.withContentTypeJson */.oK.withContentTypeJson(util_bs/* HeadersUtil.build */.oK.build(undefined))));
    var request = Fetch_bs/* RequestInit.make */.qv.make(/* Put */ 3, caml_option/* some */.G(headers), caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var headerlessRequest = Fetch_bs/* RequestInit.make */.qv.make(/* Put */ 3, undefined, caml_option/* some */.G(JSON.stringify(payload)), undefined, undefined, /* CORS */ 3, /* SameOrigin */ 1, undefined, undefined, undefined, undefined, undefined)(undefined);
    var callback = function callback(response) {
        return Request_bs/* checkResponse */.mm(response, EditScheduleDeliveryData_bs_Decode.safeDecodeResendResponse);
    };
    return Request_bs/* makeRequest */.$f(updateGiftScheduledDeliveryUrl, request, headerlessRequest, callback, true);
}
 /* Util Not a pure module */ 


/***/ })

}]);